import React from 'react'
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { useJwt } from 'react-jwt';

interface Claims {
    role: {
        name: string;
    };
}

const RedirectLogin = () => {
    const storageToken = secureLocalStorage.getItem("token");
    const token = typeof storageToken === "string" ? storageToken : null;
    const { decodedToken } = useJwt<Claims>(token || "");

    try {

        const role = decodedToken?.role.name;

        if (role === "ROLE_ADMIN") {
            return <Navigate to="/dashboardAdmin" replace />;
        } else {
            return <Navigate to="/dashboard" replace />;
        }

    } catch (error) {
        return <Navigate to="/" replace />;
    }
}

export default RedirectLogin;